import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {CollaborationService} from "../../services/Collaboration.service";
import {StateService} from "../../services/StateService";
import {DomSanitizer} from "@angular/platform-browser";
import {DateFormater} from "../../services/DateFormatter.service";
import {SwitchBoard} from "../../services/SwitchBoard";
import {ActivatedRoute, Router} from "@angular/router";
import {LoadingService} from "../../services/LoadingService";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../services/Session";
import {PostWallComponent} from "../post-wall/post-wall.component";

declare const _: any;
declare const moment: any;

@Component({
  selector: 'app-post-wrapper',
  standalone: true,
  imports: [CommonModule, FormsModule, PostWallComponent],
  templateUrl: './post-wrapper.component.html',
  styleUrl: './post-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PostWrapperComponent implements OnInit, OnDestroy {
  @Input() singlePostId;
  @Input() singlePostCompany;
  @Input() taskSinglePost: boolean;
  @Input() taskSinglePostData;
  @Input() taskId;
  postId: string;
  isDocView: boolean;
  pageType: string;
  post: any;
  docTypeList = ['doc', 'pdf', 'docx', 'xls'];
  taskTypes = ['Reminder', 'Task Reminder', 'Block Party', 'Progress Alert', 'Task Update', 'Task Creation',
    'Task Assignment', 'Company creation', 'Task Notes', 'Invoice Payment', 'London bells are ringing', 'Payme', 'Notify Mention'];
  displayType: string;
  postStatus: Array<any> = [];
  users: any;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  channelId: string = '';
  channelType: string = '';
  org: string = '';
  user: string;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private dss: DomSanitizer,
    private loadingService: LoadingService,
    private dateFormater: DateFormater,
    private switchBoard: SwitchBoard,
    private changeDetectorRef: ChangeDetectorRef,
    private collaborationService: CollaborationService,
    private stateService: StateService) {
  }

  ngOnInit(): void {
    this._init();
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this.handleRouteParams();
    this.users = Session.getUsers();
    this.switchBoard.onEditTaskAttachments
      .pipe(takeUntil(this.destroy$))
      .subscribe(next => {
        if (this.taskSinglePost) {
          this.getPost();
        }
      });
  }

  handleRouteParams() {
    this._route.data.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.displayType = data.displayType;
      this.pageType = data.pageType;
    });
    this._route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      let requestId = params['requestId'];
      let postId = params['postId'];
      this.channelId = params['channelId'];
      this.channelType = params['channelType'];
      if (this.channelType == 'companies' || this.channelType === 'clients') {
        if (!_.isEmpty(this.taskSinglePostData)) {
          this.post = {...this.taskSinglePostData};
        }
      } else if (this.channelType == 'orgs') {
        this.pageType = 'orgs';
        this.postId = postId;
        this.getPost();
      }
    });
  }

  getPost() {
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    this.collaborationService.getPost(this.org, this.channelType, this.channelId, this.postId)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.updateSnapShots(response);
        if (!response.comments) {
          response['comments'] = [];
        }
        if (!response.badges) {
          response['badges'] = [];
        }
        if (!response.tags) {
          response['tags'] = [];
        }
        if (!response.post_handlers) {
          response['post_handlers'] = [];
        }
        if (response && response.post_status && _.isEmpty(response.post_status)) {
          response['post_status'] = {id: '', name: ''};
        }
        if (!response.new) {
          response['new'] = false;
        }
        this.updateSnapShots(response);
        this.post = {...response};
        this.changeDetectorRef.detectChanges();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  updateDateTimeStamp(date) {
    const serviceFormat = 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = 'Do MMM, YYYY HH:mm';
    const startTime = moment.utc(date).toDate();
    return this.dateFormater.formatDate(startTime, serviceFormat, dateFormat);
  }

  updateDateTimeStampForTooltip(date) {
    const serviceFormat = 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = 'Do MMM, YYYY HH:mm';
    const startTime = moment.utc(date).toDate();
    return this.dateFormater.formatDate(startTime, serviceFormat, dateFormat);
  }

  updateSnapShots(post) {
    let base = this;
    post.tooltipDate = base.updateDateTimeStamp(post.createdDate);
    post.displayDate = base.updateDateTimeStampForTooltip(post.createdDate);
    post['displayLine'] = false;
    if (post.entityType === 'org' && post.entityID === '') {
      post['isOrgBroadcast'] = true;
    }
    post.isBotMessage = base.checkForEntityType(post.entityType) && post.entityType !== 'team summary' && post.entityType !== 'Task Summary';
    post.showReminder = !base.checkForEntityType(post.entityType) && post.entityType !== 'team summary' && post.entityType !== 'Task Summary';
    post.documents = post.documents ? post.documents : [];
    post.comments = post.comments ? post.comments : [];
    _.each(post.documents, function (attachment) {
      let splitArray = attachment.name.split('.');
      if (base.isImage(splitArray[splitArray.length - 1]) && attachment.temporaryURL) {
        attachment.imageType = true;
        attachment.displayImage = true;
      }
    });

    post.comments = post.comments ? post.comments : [];
    _.each(post.comments, function (comment) {
      comment.tooltipDate = base.updateDateTimeStamp(comment.createdDate);
      comment.displayDate = base.updateDateTimeStampForTooltip(comment.createdDate);
      comment.documents = comment.documents ? comment.documents : [];
      _.each(comment.documents, function (attachment) {
        if (base.isDocView) {
          let splitArray = attachment.name.split('.');
          if (base.isImage(splitArray[splitArray.length - 1])) {
            attachment.imageType = true;
            attachment.displayImage = true;
            attachment.taxCheck = attachment.taxCheck ? attachment.taxCheck : '#e1e1e1';
          } else if (base.docTypeList.indexOf(splitArray[splitArray.length - 1].toLowerCase()) != -1) {
            attachment.ispdf = true;
            attachment.displayPdf = true;
            attachment.taxCheck = attachment.taxCheck ? attachment.taxCheck : '#e1e1e1';
            let link = 'https://docs.google.com/gview?embedded=true&url=' + encodeURIComponent(attachment.temporaryURL);
            setTimeout(function () {
              attachment.pdfLink = base.dss.bypassSecurityTrustResourceUrl(link);
            }, 0);
          }
        } else {
          let splitArray = attachment.name.split('.');
          if (base.isImage(splitArray[splitArray.length - 1]) && attachment.temporaryURL) {
            attachment.imageType = true;
            attachment.displayImage = true;
          }
        }
      });
    });
    return post;
  }

  _init() {
    this.switchBoard.onClickPrev.pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        let prevState = this.stateService.getPrevState();
        if (prevState && prevState.url) {
          prevState.url = prevState.url.split('(')[0];
        }
        if (prevState && prevState.key === 'channel-tasks') {
          this._router.navigate([prevState.url]);
        } else if (prevState && prevState.key == 'KARLIE') {
          this._router.navigate([prevState.url]);
        } else if (prevState) {
          this._router.navigate([prevState.url]);
        }
      });
  }

  checkForEntityType(type) {
    if (this.taskTypes.indexOf(type) !== -1) {
      return false;
    } else {
      return true;
    }
  }

  isImage(extension) {
    let imageTypes = ['png', 'jpg', 'jpeg', 'bmp'];
    if (imageTypes.indexOf(extension.toLowerCase()) != -1) {
      return true;
    } else {
      return false;
    }
  }

  deletePost($event) {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  processPostData(post) {
    this.loadingService.triggerLoadingEvent(false);
    this.updateSnapShots(post);
    if (!post.comments) {
      post['comments'] = [];
    }
    if (!post.badges) {
      post['badges'] = [];
    }
    if (!post.new) {
      post['new'] = false;
    }
    this.updateSnapShots(post);
    this.post = {...post};
    this.changeDetectorRef.detectChanges();
  }

}
